export default "__VITE_ASSET__MiDfIIuH__"